<template>
    <div class="message-row">
        <div
            :class="{
                'message-row__align-right': messageAlignRight,
                'message-row__align-left': !messageAlignRight,
            }"
        >
            <common-user-avatar
                v-if="showUserAvatar"
                :user="{
                    name: message.fromUser.firstName + ' ' + message.fromUser.lastName,
                    avatar: referral.fromUser.avatar,
                }"
                size="label"
                :isUserProfileLinkEnabled="false"
                :class="[{ 'message-row__order-left': userId === message.fromUser.id }, 'message-row__avatar']"
            ></common-user-avatar>
            <common-ancillary-avatar
                v-if="showAncillaryAvatar"
                :ancillary="{
                    name: ancilaryName,
                }"
                size="label"
                :class="[{ 'message-row__order-left': messageAlignRight }, 'message-row__avatar']"
            ></common-ancillary-avatar>

            <div>
                <p v-if="showMessageHeader" class="message-row__header">
                    {{ $t('elements.referrals.messages.message_row.header_text') }}
                </p>
                <p v-if="message.body.length" class="message-row__body" v-html="message.body"></p>
                <div v-if="message.attachments.length && showAttachment" class="message-row__attachments">
                    <common-summary-item
                        :label="$t('pages.referrals.show.details.attachments', { n: message.attachments.length })"
                        :isInline="false"
                        :isCompact="false"
                        width="full"
                    >
                        <common-images ref="images" :images="message.attachments"></common-images>
                    </common-summary-item>
                </div>
                <p v-if="formatedDate" class="message-row__date">{{ formatedDate }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        props: {
            message: { type: Object, required: true },
            userId: { type: Number, required: false, default: null },
            referral: { type: Object, required: false, default: () => {} },
            showAttachment: { type: Boolean, default: false },
            isBothPracticesAncillary: { type: Boolean, default: false },
            practice: { type: Object, required: false, default: () => {} },
        },
        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },
        computed: {
            showUserAvatar() {
                return !this.isBothPracticesAncillary && this.message.fromUser && this.userId !== this.message.fromUser.id
            },
            showAncillaryAvatar() {
                if (this.isBothPracticesAncillary && !this.messageAlignRight) {
                    return true
                }

                return (
                    this.message.toUser?.id === this.userId && this.referral.practice.practiceType === PracticeTypeEnum.ANCILLARY
                )
            },
            ancilaryName() {
                if (this.isBothPracticesAncillary) {
                    return this.message?.fromPractice?.name
                } else {
                    return this.referral?.practice?.name
                }
            },
            messageAlignRight() {
                if (!this.isBothPracticesAncillary) {
                    return this.userId === (this.message?.fromUser ? this.message?.fromUser?.id : null)
                }

                return this.message?.fromPractice.id === this.practice?.id ? this.message?.fromPractice.id : null
            },
            showMessageHeader() {
                if (this.isBothPracticesAncillary && this.messageAlignRight) {
                    return this.message.fromPractice
                } else if (this.isBothPracticesAncillary) {
                    return this.practice === this.message.fromPractice
                } else {
                    return this.userId === (this.message.fromUser ? this.message.fromUser.id : null)
                }
            },
            formatedDate() {
                return dayjs(this.message.createdDateTime).format('MMM DD YYYY hh:mm:ss')
            },
        },
    }
</script>
